import { ChartData } from "&/types/layout-workspace/components/chart-output/typings/chart-data.type";
import { RawChartData } from "&/types/layout-workspace/components/chart-output/typings/raw-chart-data.type";
import { VuexModuleName } from "&/types/vuex/enums/module-name.enum";
import { SET_CHART_DATA } from "@/store/chart-output.module/mutations/set-chart-data.mutation";
import { ChartTemplateDocument } from "@wave-charts/core/dist/src/storage/interfaces/chart-template.interface";
import Component from "vue-class-component";
import { Mixins, Watch, Prop } from "vue-property-decorator";
import { getTemplateRawChartData } from "../services/rxdb-services/get-template-chart-data.service";
import { TemplateObserverMixin } from "./template-observer.mixin";

/**
 * 依赖图表配置项（chartOutputMetadata）的组件的公共类
 *
 * @export
 * @class ChartOutputMetadataObserverMixin
 * @extends {Vue}
 */
@Component
export class ChartOutputMetadataObserverMixin extends Mixins(
  TemplateObserverMixin,
) {
  @Prop({ default: false }) readonly shareMode!: boolean;
  @Prop() readonly chartOutputMetadataShare!: any;
  @Prop() readonly chartTemplateConfig!: any;

  /**
   * 当前选中模版的样例数据
   *
   * @type {RawChartData}
   * @memberof ChartOutputMetadataObserverMixin
   */
  templateRawChartData: RawChartData = null;

  /**
   * 图表配置项
   *
   * @readonly
   * @memberof ChartOutputMetadataObserverMixin
   */
  get chartOutputMetadata() {
    if (this.shareMode) return this.chartOutputMetadataShare;
    return this.$stock.state[VuexModuleName.CHART_OUTPUT].metadata;
  }

  /**
   * 配置项中读取的图表数据
   *
   * @readonly
   * @memberof ChartOutputMetadataObserverMixin
   */
  get inputedRawChartData(): RawChartData {
    return this.chartOutputMetadata.rawChartData; // default is [[]]
  }
  /**
   * 用于加工的原始数据
   *
   * @readonly
   * @memberof ChartOutputMetadataObserverMixin
   */
  get rawChartData(): RawChartData {
    if (
      this.inputedRawChartData.length <= 0 ||
      this.inputedRawChartData[0].length <= 0
    ) {
      return this.templateRawChartData;
    }
    return this.inputedRawChartData;
  }
  /**
   * 实际的图表数据
   *
   * @readonly
   * @type {ChartData}
   * @memberof ChartOutputMetadataObserverMixin
   */
  get chartData(): ChartData {
    return this.$stock.state[VuexModuleName.CHART_OUTPUT].chartData;
  }
  set chartData(data: ChartData) {
    this.$stock.commit(SET_CHART_DATA, data);
  }

  /**
   * 监听当前选中的模版，更新图表模版数据
   *
   * @param {ChartTemplateDocument} doc
   * @memberof ChartOutputMetadataObserverMixin
   */
  @Watch("selectedTemplateDoc", { immediate: true })
  async watchAndGetTemplateRawChartData(doc: ChartTemplateDocument) {
    if (!doc) return;
    if (this.shareMode) {
      try {
        this.templateRawChartData = this.chartTemplateConfig.attachments[
          "data.json5"
        ];
      } catch (err) {
        console.log(err);
      }
    } else this.templateRawChartData = await getTemplateRawChartData(doc);
  }

  @Watch("chartTemplateConfig", { immediate: true })
  async watchAndGetTemplateRawChartDataShareMode(doc: ChartTemplateDocument) {
    if (!doc) return;
    if (this.shareMode) {
      try {
        this.templateRawChartData = this.chartTemplateConfig.attachments[
          "data.json5"
        ];
      } catch (err) {
        console.log(err);
      }
    } else this.templateRawChartData = await getTemplateRawChartData(doc);
  }
}
